export default __webpack_public_path__ + "static/media/undraw_teacher_35j2.30b54f19.svg";